/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * When agent was assigned
 * @export
 * @interface AssignedAt
 */
export interface AssignedAt {
}

/**
 * Check if a given object implements the AssignedAt interface.
 */
export function instanceOfAssignedAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AssignedAtFromJSON(json: any): AssignedAt {
    return AssignedAtFromJSONTyped(json, false);
}

export function AssignedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignedAt {
    return json;
}

export function AssignedAtToJSON(value?: AssignedAt | null): any {
    return value;
}

